

export class GenericPagingVM {
    
    pageNo?: number;
    
    pageSize?: number;
    
    items?: any[];
    
    totalItems?: number;
    
    totalPages?: number;
    
    pagingTokens?: string[];
    
    nextPagingToken?: string;
    
}
